export default __webpack_public_path__ + "static/media/puce-01.ab09f371.webp";